import React from 'react';
import { InputGroup } from 'react-bootstrap';
import './AntDatePickerFields.css';
import InfoBar from '../InfoBars';
import dayjs from 'dayjs';
import {DatePicker} from 'antd';
import Vectoricon from '../../../assets/svg/Vector.svg';
import DisabledCalenderIcon from '../../../assets/svg/DisabledCalender.svg';
import { all } from 'axios';

interface InputFieldProps {
  placeholder: string;
  inputType?: 'general' | 'entered' | 'error' | 'success' | 'disabled';
  type: string; //text | email | password |
  isDisabled: boolean;
  className?: string;
  labelName?: string;
  required?: boolean;
  onChange: (value: string,event?:any) => void;
  value?: any;
  maximumLength?: number ;
  inputId?:any;
  errorMessage?:string;
  disablePastDates?:boolean;
  maxDate?:string;
  minDate?:string;
  onClick?:()=>void;
  showTime?:boolean;
  showDateTimeFormat?:boolean;
  showOnlyTime?:boolean;
  disableIndividualDates?: any[];
  useRelativePopup?: boolean;
  allowClear?: boolean;
}
const AntDateFieldsComponent = ({
  inputType = 'general',
  placeholder,
  type,
  isDisabled,
  className,
  labelName,
  required,
  onChange,
  value,
  maximumLength,
  inputId,
  errorMessage,
  disablePastDates,
  maxDate,
  minDate,
  onClick,
  showTime,
  showDateTimeFormat,
  showOnlyTime,
  disableIndividualDates = [],
  useRelativePopup = false,
  allowClear = true
}: InputFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | any) => {
    onChange(e);
  };

  const disableSepcificdates = (current: any) => {
    return disableIndividualDates?.some((date: any) => current.isSame(dayjs(date), 'day'));
  };

  const placement = useRelativePopup ? "bottomLeft" : undefined;
  const getPopupContainer = useRelativePopup
    ? (trigger: HTMLElement) => trigger.parentElement as HTMLElement
    : undefined;

  return (
    <div className={`input-field-container  ${className}`}>
      {labelName && (
        <label
          className={`label-name-from-parent ${required && 'yes'} ${isDisabled}`}
        >
          {labelName}
        </label>
      )}
      <InputGroup
        className={` input-field-group input-field-group-${inputType}`}
        onClick={()=>{
          if(onClick){
            onClick();
          }
        }}
      >
        
      <DatePicker id={inputId} format={showOnlyTime ? 'hh:mm A' : showTime ? (showDateTimeFormat ? 'DD-MM-YYYY hh:mm A' : 'hh:mm A') : type === 'month' ? 'MMM-YYYY' : 'DD-MM-YYYY'} placeholder={showOnlyTime ? 'hh:mm A' : showTime ? (showDateTimeFormat ? 'DD-MM-YYYY hh:mm A' : 'hh:mm A') : type === 'month' ? 'MMM-YYYY' :'DD-MM-YYYY'} minDate={minDate ? dayjs(minDate) : undefined} allowClear={allowClear} maxDate={maxDate ? dayjs(maxDate): undefined}  onChange={handleChange} value={value? dayjs(value) : undefined} disabled={isDisabled} className={className} popupClassName={`date-picker-popup ${placement === 'bottomLeft' ? 'onlyForBottom' : ''}`} suffixIcon={isDisabled ? <DisabledCalenderIcon /> : <Vectoricon />} showTime={showTime ? { use12Hours: true } : false} picker={showOnlyTime ? 'time' : type === 'month' ? 'month' : 'date'} disabledDate={(disableIndividualDates && disableIndividualDates.length) > 0 ? disableSepcificdates : undefined} placement={placement} popupAlign={placement === 'bottomLeft' ? {
        points: ['tl', 'bl'],
        offset: [0, 4]
      } : undefined} getPopupContainer={getPopupContainer}/>
      
      </InputGroup>
      <div className="input_field_infoBars">
        {inputType === 'success' ? (
          <InfoBar
            variant="success"
            message={errorMessage?errorMessage:'Success'}
            className="input_field_class"
          />
        ) : (
          ''
        )}
        {inputType === 'error' ? (
          <InfoBar
            variant="danger"
            message={errorMessage?errorMessage:''}
            className="input_field_class"
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
export default AntDateFieldsComponent;
